export default __webpack_public_path__ + "static/media/recommended_reading_transparent_-_resources_page-removebg-preview.78555277.png";